import { render, staticRenderFns } from "./DetailBatchLelangItem.vue?vue&type=template&id=67e878a9&"
import script from "./DetailBatchLelangItem.vue?vue&type=script&lang=js&"
export * from "./DetailBatchLelangItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports